module.exports = __webpack_public_path__ + "img/join_store.6bdd920f.svg";